import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,

} from '@coreui/react-pro'
import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'


import useNavSideBar from '../../../routes/hook/useNavSideBar'
import { COLORS } from '../../../../core/constants/colors'
import { useUIStore } from '../../../../core/store'

import logoAPP from "../../../../core/assets/img/logo.png"
import NavItemCustom from '../nav-item-custom/NavItemCustom'
import { FaRegHandshake } from 'react-icons/fa'
import { IoExitOutline } from 'react-icons/io5'


const AppSidebar = () => {
  const dispatch = useDispatch()
  // const unfoldable = useTypedSelector((state) => state.sidebarUnfoldable)
  // const sidebarShow = useTypedSelector((state) => state.sidebarShow)

  // const { sidebarUnfoldable: unfoldable, sidebarShow } = useSelector((state: RootState) => state.ui);

  const { sidebarShow, sidebarUnfoldable, setUI } = useUIStore(state => state)


  const navigation = useNavSideBar();

  return (
    <CSidebar
      position="fixed"
      unfoldable={sidebarUnfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        setUI({ sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" style={{ backgroundColor: COLORS.tertiaryColor }}>

        {/* <img className="sidebar-brand-full" src={logoAPP} alt="My Cool Image" height={90} />
       {/* <img className="sidebar-brand-narrow" src={logoAPP} alt="My Cool Image" height={30} /> */}

        <img className="sidebar-brand-full invert" src={logoAPP} alt="logo company" width={180} height={10} />
        {/* <img className="sidebar-brand-narrow invert" src={logoAPP} alt="logo company" width={100} height={10} /> */}

      </CSidebarBrand>

      <CSidebarNav>
        <div className='h-full  flex flex-col justify-between'>
          <SimpleBar >
            <div className='mb-4'>
              <AppSidebarNav items={navigation} />
            </div>
          </SimpleBar>

          <div className='mb-2'>
            <AppSidebarNav items={[
              {
                component: NavItemCustom,
                name: "Salir",
                roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
                icon: <IoExitOutline className="nav-icon-menu" />,
                to: "/login",
              },
            ]} />
          </div>

        </div>
      </CSidebarNav>


      {/* TODO: Impide que se achique el sidebar principal */}
      {/* <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() =>
          setUI({ sidebarUnfoldable: !sidebarUnfoldable })
        }
      /> */}
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
